import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';
import {ApiAgentService} from '../../services/api-agent.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Router, RouterModule} from '@angular/router';
import {WithdrawDialogComponent} from './withdraw-dialog/withdraw-dialog.component';

declare var Snackbar: any;

@Component({
  selector: 'app-affiliate-page',
  templateUrl: './affiliate-page.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, WithdrawDialogComponent],
  styleUrl: './affiliate-page.component.scss'
})
export class AffiliatePageComponent implements OnInit {

  // todo: Dashboard Notification: Display a notification or banner in the dashboard highlighting the affiliate program and providing a link to learn more.
  // todo: Affiliate Tab: Add an "Affiliate Program" tab in the dashboard menu where merchants can find all the relevant information and sign-up link.
  // todo: Send periodic reminders and updates about the affiliate program through email newsletters, in-app notifications, or dashboard alerts. Keep merchants informed about any changes, new benefits, or success stories.

  @ViewChild('affiliateLink') affiliateLink: ElementRef;
  @ViewChild(WithdrawDialogComponent) withdrawDialog: WithdrawDialogComponent;

  affiliateLinkUrl: any;
  affiliateBalance: number;
  affiliateMerchantsCount: number;

  ngOnInit() {
    this.loadResources().then();
    this.loadAffiliateData().then(r => console.log(r));
  }

  constructor(private loader: GlobalLoaderService,
              private router: Router,
              private api: ApiAgentService,
              private translate: TranslateService) {
  }

  async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
  }

  async loadAffiliateData() {
    try {
      const linkData = await this.api.getAffiliateLink();
      this.affiliateLinkUrl = linkData.affiliateLink;

      const balanceData = await this.api.getAffiliateBalance();
      this.affiliateBalance = balanceData.affiliateBalance;

      const merchantsData = await this.api.getAffiliateMerchantsCount();
      this.affiliateMerchantsCount = merchantsData.affiliateMerchantsCount;
    } catch (error) {
      console.error('Error loading affiliate data:', error);
      this.showToast(await firstValueFrom(this.translate.get('Error loading affiliate data')));
    }
  }

  async copyAffiliateLink() {
    this.affiliateLink.nativeElement.select();
    this.affiliateLink.nativeElement.setSelectionRange(0, 99999); // For mobile devices
    this.showToast(await firstValueFrom(this.translate.get('Link copied to clipboard!')));
    document.execCommand('copy');
  }

  private showToast(msg: string) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  openInvoices() {
    this.router.navigate(['/private/affiliate-invoices']).then();
  }

  withdrawBalance() {
    // display a dialog to confirm the withdrawal
    this.withdrawDialog.show();
  }

  async onWithdrawConfirm(amount: number) {
    try {
      // The dialog component has already set submitting=true

      // Create withdrawal request
      await this.api.createAffiliateWithdrawRequest(amount);

      // Refresh the balance
      const balanceData = await this.api.getAffiliateBalance();
      this.affiliateBalance = balanceData.affiliateBalance;

      // Show a success message
      this.showToast(await firstValueFrom(this.translate.get('Withdrawal request submitted successfully')));

      // Hide the dialog
      this.withdrawDialog.hide();
    } catch (error) {
      console.error('Error submitting withdrawal request:', error);
      this.showToast(await firstValueFrom(this.translate.get('Error submitting withdrawal request')));
    } finally {
      // Always make sure to reset the submitting state
      this.withdrawDialog.submitting = false;
    }
  }

  viewMerchants() {
    this.router.navigate(['/private/affiliate-merchants']).then();
  }

  viewWithdrawHistory() {
    this.router.navigate(['/private/affiliate-withdraw-history']).then();
  }
}
